export enum StudentSectionMode {
	View = 'view',
	Edit = 'edit',
	Rearrange = 'rearrange',
	Add = 'add',
}
